export { DirectGeometry } from "./DirectGeometry";
export { Face3 } from "./Face3";
export { Gmetry } from "./Gmetry";
export { ThreeGeometryHellfix } from "./mylibrary";
//# sourceMappingURL=index.js.map